import type {TprmQuestionnaireTemplate, TprmQuestionTemplateId} from "platformed-client/types";

export function numberVisibleQuestions(
  template: TprmQuestionnaireTemplate,
  isVisible: (questionId: TprmQuestionTemplateId) => boolean,
): Map<TprmQuestionTemplateId, string> {
  const numbers = new Map<TprmQuestionTemplateId, string>();
  const mode = template.numbering_mode;

  template.sections.forEach((section, sectionIndex) => {
    let visibleQuestionIndex = 0;

    section.questions.forEach((question, questionIndex) => {
      if (!isVisible(question.question_template_id)) return;
      visibleQuestionIndex++;

      switch (mode) {
        case "AutoContinuous":
          numbers.set(question.question_template_id, `${sectionIndex + 1}.${visibleQuestionIndex}`);
          break;
        case "AutoStable":
          numbers.set(question.question_template_id, `${sectionIndex + 1}.${questionIndex + 1}`);
          break;
        case "Manual":
          if (question.question_number == null) {
            throw new Error("Manual questionnaire numbering requires every question to have a number");
          }
          numbers.set(question.question_template_id, question.question_number);
          break;
      }
    });
  });

  return numbers;
}
